import UserProfileComponent from './UserProfileComponent';
import BioForm from './Forms/BioForm';

export default class Bio extends UserProfileComponent {
    templateId() {
        return '#bioTemplate';
    }

    form() {
        return new BioForm(this.loader);
    }

    data() {
        return '/dashboard/profile/ajax/getBio';
    }
}
